<template>
  <div class="base-select form-group">
    <div
      class="px-0"
      :class="`col-${col}`">
      <b-form-select
        :id="name"
        class="base-select__select"
        :value="_value"
        :name="name"
        :class="fieldClass"
        :placeholder="placeholder"
        :options="optionsWithPlaceholder"
        :disabled="disabled"
        v-on="$listeners" />
    </div>
    <BaseErrorMessage :errors="errors" />
  </div>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  name: 'BaseSelect',
  components: {
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldClass: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    hasPlaceholder() {
      return this.placeholder != null
    },
    placeholderOption() {
      return { value: null, text: this.placeholder, disabled: true }
    },
    optionsWithPlaceholder() {
      if (this.hasPlaceholder) {
        return [this.placeholderOption, ...this.options]
      }
      return this.options
    }
  },
}
</script>

<style lang="scss" scoped>
.base-select {
  width: 100%;
  margin-bottom: 0;

  &__select {
    height: 48px;
  }
}
</style>